import { render, staticRenderFns } from "./selecForm.vue?vue&type=template&id=671bfa1b&scoped=true&"
import script from "./selecForm.vue?vue&type=script&lang=js&"
export * from "./selecForm.vue?vue&type=script&lang=js&"
import style0 from "./selecForm.vue?vue&type=style&index=0&id=671bfa1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671bfa1b",
  null
  
)

export default component.exports